const state = () => ({
    posicao: null,
    posicaoAntecipacao: null,
    selecionado: {},
    selecionadoAntecipacao: {}
});

const getters = {
    getPosicao: (state) => {
      return state.posicao
    },

    getPosicaoAntecipacao: (state) => {
      return state.posicaoAntecipacao
    },

    getSelecionado: (state) => {
      return state.selecionado
    },
    
    getSelecionadoAntecipacao: (state) => {
      return state.selecionadoAntecipacao
    }
};

const mutations = {
    SET_POSICAO (state, posicao) {
      state.posicao = posicao
    },

    SET_POSICAO_ANTECIPACAO (state, posicao) {
      state.posicaoAntecipacao = posicao
    },

    SET_SELECIONADO (state, dados) {
      state.selecionado = dados
    },

    SET_SELECIONADO_ANTECIPACAO (state, dados) {
      state.selecionadoAntecipacao = dados
    },

    SET_LIMPA_POSICAO (state) {
      state.posicao = null
    }
};

const actions = {
  setPosicao({ commit }, posicao) {
    commit('SET_POSICAO', posicao)
  },

  setPosicaoAntecipacao({ commit }, posicao) {
    commit('SET_POSICAO_ANTECIPACAO', posicao)
  },

  setSelecionado({ commit } , dados) {
    commit('SET_SELECIONADO', dados)
  },

  setSelecionadoAntecipacao({ commit } , dados) {
    commit('SET_SELECIONADO_ANTECIPACAO', dados)
  },

  setLimpaPosicao({commit}) {
    commit('SET_LIMPA_POSICAO')
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};